import { useMemo } from 'react';

import { ProfileHeader, SkeletonLoader } from '@equip.health/ui';
import { capitalize } from 'lodash';

interface ProviderProfileHeaderProps {
  credentials?: string[];
  pronouns?: string[];
  firstName: string;
  lastName: string;
  middleName?: string;
  providerTypeName: string;
  otherPronounText?: string;
  stateOfResidence?: string;
  suffix?: string;
  isLoading?: boolean;
  avatarUrl?: string;
}

const ProviderProfileHeader = ({
  credentials,
  firstName,
  lastName,
  middleName,
  providerTypeName,
  pronouns,
  otherPronounText,
  isLoading,
  stateOfResidence,
  suffix,
  avatarUrl,
}: ProviderProfileHeaderProps) => {
  const TOP_LEVEL_ID = 'provider-profile-header';
  const updatedPronouns = useMemo(
    () =>
      pronouns?.map((item) => {
        const pronounText = item?.toLowerCase() === 'other';
        return pronounText ? capitalize(otherPronounText) || 'Other' : item;
      }),
    [pronouns, otherPronounText],
  );
  return (
    <SkeletonLoader id={`${TOP_LEVEL_ID}__loader`} isLoaded={!isLoading}>
      <ProfileHeader
        avatarUrl={avatarUrl}
        credentials={credentials}
        firstName={firstName}
        id={TOP_LEVEL_ID}
        lastName={lastName}
        middleName={middleName}
        pronouns={updatedPronouns}
        providerTypeName={providerTypeName}
        stateOfResidence={stateOfResidence}
        suffix={suffix}
      />
    </SkeletonLoader>
  );
};

export default ProviderProfileHeader;
